export default __webpack_public_path__ + "static/media/background_register.1c797d68.jpg";